<template>
  <aside
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 h-100"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-lg-block d-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a
        class="navbar-brand m-0 text-center"
        href="/"
        target="_blank"
        style="padding-bottom: 2px; padding-top: 2px"
      >
        <img
          src="../core_assets/img/CCD_LOGO_2.png"
          class="navbar-brand-img h-100"
          alt="main_logo"
          style="width: auto; height: auto; max-height: 4.5rem"
        />
      </a>
    </div>
    <hr class="horizontal dark mt-0" />
    <div class="collapse navbar-collapse w-auto" id="sidenav-collapse-main">
      <strong
        class="d-flex"
        style="
          color: black;
          font-size: medium;
          justify-content: center !important;
        "
        >Menú</strong
      >
      <ul class="navbar-nav mt-3">
        <li class="nav-item" @click="goToRoute('/overview')">
          <a
            class="nav-link"
            :class="{ active: $route.path.includes('/overview') }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <v-icon
              v-if="$route.path.includes('/overview')"
              fill="white"
              name="home"
            ></v-icon>
            <v-icon v-else fill="#CCCCCC" name="home"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Inicio</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/postulation')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/postulation') ||
                $route.path == '/postulation',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <v-icon
              v-if="
                $route.path.includes('/postulation') ||
                $route.path == '/postulation'
              "
              fill="white"
              name="medal"
            ></v-icon>
            <v-icon v-else fill="#CCCCCC" name="medal"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mis postulaciones</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/my-payments')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/my-payments') ||
                $route.path == '/my-payments',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <v-icon
              v-if="
                $route.path.includes('/my-payments') ||
                $route.path == '/my-payments'
              "
              fill="white"
              name="money-bill"
            ></v-icon>
            <v-icon v-else fill="#CCCCCC" name="money-bill"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mis pagos</span
            >
          </a>
        </li>
        <li class="nav-item mt-2" @click="goToRoute('/profile')">
          <a
            class="nav-link"
            :class="{
              active:
                $route.path.includes('/profile') || $route.path == '/profile',
            }"
            style="cursor: pointer; border-radius: 5%/50%; height: 30px"
          >
            <v-icon
              v-if="
                $route.path.includes('/profile') || $route.path == '/profile'
              "
              fill="white"
              name="users"
            ></v-icon>
            <v-icon v-else fill="#CCCCCC" name="users"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Mi perfil</span
            >
          </a>
        </li>
        <li v-if="isTrainerAndFormerPlayer || isTrainer" class="nav-item mt-2" @click="goToURL('https://www.conmebol.com/entrenadores-con-licencia-conmebol/')">
          <a
            class="nav-link"
            style="
              cursor: pointer;
              border-radius: 5%/50%;
              height: 30px;
              width: 232px;
            "
          >
            <v-icon fill="#CCCCCC" name="file-alt"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none"
              >Conmebol</span
            >
          </a>
        </li>
        <li v-if="isTrainerAndFormerPlayer || isTrainer" class="nav-item mt-2" @click="goToURL('https://rne.federacionvenezolanafutbol.com/iniciar_sesion')">
          <a
            class="nav-link"
            style="
              cursor: pointer;
              border-radius: 5%/50%;
              height: 30px;
              width: 232px;
            "
          >
            <v-icon fill="#CCCCCC" name="id-card"></v-icon>
            <span class="nav-link-text ms-3" style="text-transform: none"
              >RNE</span
            >
          </a>
        </li>
        <!-- <li  class="nav-item mt-2" @click="goToRoute('/clubs/mydata')">
            <a class="nav-link" :class="{ 'active': $route.path === '/clubs/mydata'}" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
              <v-icon v-if="$route.path === '/clubs/mydata'" fill="white" name="futbol"></v-icon>
              <v-icon v-else fill="#CCCCCC" name="futbol"></v-icon>
              <span class="nav-link-text ms-3" style="text-transform: none;">Mis Datos</span>
            </a>
          </li>
          <li  class="nav-item mt-2" @click="goToRoute('/clubs/myfile')">
            <a class="nav-link" :class="{ 'active': $route.path === '/clubs/myfile'}" style="cursor:pointer; border-radius: 5%/50%; height: 30px;">
              <v-icon v-if="$route.path === '/clubs/myfile'" fill="white" name="users"></v-icon>
              <v-icon v-else fill="#CCCCCC" name="users"></v-icon>
              <span class="nav-link-text ms-3" style="text-transform: none;">Mis Archivos</span>
            </a>
          </li> -->
      </ul>
    </div>
    <div class="sidenav-footer mx-3">
      <!-- <div style="cursor:pointer" @click="goToRoute('/admin/ayuda')"
        class="card card-background shadow-none card-background-mask-secondary" id="sidenavCard">
        <div class="full-background" style="background-image: url('../core_assets/img/curved-images/white-curved.jpg')">
        </div>
        <div class="card-body text-start p-3 w-100">
          <div
            class="icon icon-shape icon-sm bg-white shadow text-center mb-3 d-flex align-items-center justify-content-center border-radius-md">
            <v-icon name="cog"></v-icon>
          </div>
          <div class="docs-info">
            <h6 class="text-white up mb-0">¿Necesitas ayuda?</h6>

            <a href="../admin/ayuda" target="_blank" class="btn btn-white btn-sm w-100 mb-0">Ayuda del sistema</a>
          </div>
        </div>
      </div> -->
      <!-- <a @click="closeSession" class="btn bg-gradient-fvf mt-3 w-100"
        style="cursor:pointer; color: rgb(255, 255, 255);">Cerrar sesión</a> -->
    </div>
    <footer
      class="footer align-items-lg-end align-items-xl-end align-items-xxl-end pt-5"
    >
      <br />
      <br />
      <br />
      <br />
      <div class="container-fluid">
        <div
          class="row align-items-center justify-content-lg-center align-items-lg-end align-items-xl-end align-items-xxl-end"
        >
          <div
            class="col-lg-12 mb-lg-0 mb-0"
            style="bottom: 100px !important; position: absolute"
          >
            <div
              class="copyright text-center text-sm text-muted text-lg-center"
              style="
                color: #cccccc !important;
                font-size: 15px !important;
                text-transform: none;
              "
            >
              Desarrollado <i class="fa fa-heart"></i> por
              <a
                href="https://ticktaps.com"
                class="font-weight-bold"
                target="_blank"
                >Ticktaps</a
              >
            </div>
          </div>
        </div>
      </div>
    </footer>
  </aside>
</template>
<script
  src="https://kit.fontawesome.com/42d5adcbca.js"
  crossorigin="anonymous"
></script>
<script>
import { mapActions } from "vuex";
import IconBox3D from "../components/Icons/Box3D";
import IconCreditCard from "../components/Icons/CreditCard";
import IconCustomerSupport from "../components/Icons/CustomerSupport";
import IconOffice from "../components/Icons/Office";
import IconShop from "../components/Icons/Shop";
import IconSpaceShip from "../components/Icons/SpaceShip";
import IconDocument from "../components/Icons/Document";
import Cookies from "js-cookie";

export default {
  components: {
    IconBox3D,
    IconCreditCard,
    IconOffice,
    IconShop,
    IconSpaceShip,
    IconDocument,
    IconCustomerSupport,
  },
  computed: {
    routeName() {
      //const {name} = this.$route
      //return this.capitalizeFirstLetter(name)
    },
    isUser() {
      if(this.id_type_user == 0){
        return true;
      }else{
        return false;
      }
    },
    isTrainer() {
      if(this.id_type_user == 1){
        return true;
      }else{
        return false;
      }
    },
    isFormerPlayer() {
      if(this.id_type_user == 2){
        return true;
      }else{
        return false;
      }
    },
    isTrainerAndFormerPlayer() {
      if(this.id_type_user == 3){
        return true;
      }else{
        return false;
      }
    },

  },
  data() {
    return {
      activeNotifications: false,
      id_type_user: Cookies.get("id_type_user"),
    };
  },
  methods: {
    ...mapActions(["logout"]),
    goToRoute(route) {
      this.$router.push(route);
      //this.$router.push('/admin/overview')
    },
    goToURL(url) {
      window.open(url, "_blank");
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    closeSession() {
      console.log("Bye Bye");
      this.logout();
      location.reload();
    },
  },
};
</script>
<style scoped>
.navbar-vertical.navbar-expand-xs .navbar-collapse {
  display: block;
  overflow: auto;
  height: max-content !important;
}
</style>

<style>
aside {
  position: fixed;
  top: 0;
  bottom: 0;
  left: -300px;
  width: 300px;
  transition: all 0.3s ease;
}

@media only screen and (max-width: 767px) {
  aside {
    left: 0;
    width: 100%;
  }

  aside.show {
    z-index: 999;
  }
}

.navbar-vertical .navbar-nav > .nav-item .nav-link.active {
  color: white !important;
  background-color: #541a32 !important;
}
.navbar-vertical .navbar-nav .nav-link {
  color: black;
}
</style>
